import React from 'react';
import * as Icons from 'lucide-react';
import { Sparkles } from 'lucide-react';
import { PageHero, CTASection } from '@/components/shared/Section';
import { INDUSTRIES } from '@/data/content';

const industryImages = {
  Construction: 'https://images.pexels.com/photos/14989321/pexels-photo-14989321.jpeg?auto=compress&cs=tinysrgb&w=900',
  Logistics: 'https://images.pexels.com/photos/4484073/pexels-photo-4484073.jpeg?w=900',
  'Real Estate': 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=900&q=80',
  SMEs: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=900&q=80',
  Manufacturing: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=900&q=80',
  'Professional Services': 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=900&q=80',
  Retail: 'https://images.unsplash.com/photo-1481437156560-3205f6a55735?w=900&q=80',
};

export default function IndustriesPage() {
  return (
    <>
      <PageHero
        eyebrow="Industries"
        title="Workforce and business solutions, calibrated by sector."
        description="Each industry has its own rhythm. Our engagement model adapts to the operating realities of every sector we serve."
      />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {INDUSTRIES.map((ind, i) => {
            const Icon = Icons[ind.icon] || Sparkles;
            const featured = i === 0 || i === 4;
            return (
              <article
                key={ind.name}
                data-testid={`industry-detail-${ind.name.toLowerCase().replace(/\s+/g, '-')}`}
                className={`group relative overflow-hidden rounded-sm border border-slate-200 bg-white transition-all hover:-translate-y-1 hover:shadow-xl ${
                  featured ? 'lg:col-span-2' : ''
                }`}
              >
                <div className={`relative ${featured ? 'h-72' : 'h-56'} overflow-hidden`}>
                  <img
                    src={industryImages[ind.name]}
                    alt={ind.name}
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#001E3D] via-[#001E3D]/30 to-transparent" />
                  <div className="absolute top-4 left-4 inline-flex h-10 w-10 items-center justify-center rounded-sm bg-white/90 backdrop-blur text-tito-blue">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div className="absolute bottom-4 left-4 right-4 text-white">
                    <div className="eyebrow text-tito-gold">Industry</div>
                    <h3 className="mt-1 font-display font-semibold text-2xl">{ind.name}</h3>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-slate-600 leading-relaxed">{ind.desc}</p>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      <CTASection />
    </>
  );
}
